
import { defineComponent } from 'vue'
import MixedChart from '@/components/charts/MixedChart.vue'
export default defineComponent({
  components: {
    MixedChart
  }
})
